import { DatepickerTypeEnum } from "../enums";
import { IMask } from "tir-pm-mask/vue-imask";
import { modifyDate } from "../utils";
import { locale } from "./locale";

export const getMaskOptions = (type: DatepickerTypeEnum) => {
  const format = (date: Date) => modifyDate(date).formatByInputType(type);
  const parse = (str: string, _date?: Date) =>
    modifyDate(
      !_date || !(_date instanceof Date) ? new Date() : new Date(_date)
    ).parseStringByInputType(str, type);

  switch (type) {
    /**
     * * Маска даты
     */
    case DatepickerTypeEnum.Date:
      return {
        mask: Date,
        pattern: "D.`M.`Y",
        eager: "append",
        autofix: "pad",
        lazy: true,
        overwrite: true,
        placeholderChar: " ",
        blocks: {
          D: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 31,
            maxLength: 2,
            minLength: 2,
          },
          M: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12,
            maxLength: 2,
            minLength: 2,
          },
          Y: {
            mask: IMask.MaskedRange,
            from: 1900,
            to: 9999,
            minLength: 4,
          },
        },
        format,
        parse,
      };
    /**
     * * Маска даты со временем
     */
    case DatepickerTypeEnum.DateTime:
      return {
        mask: Date,
        pattern: "D.`M.`Y в `h:`m",
        eager: "append",
        autofix: "pad",
        lazy: true,
        overwrite: true,
        placeholderChar: " ",
        blocks: {
          D: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 31,
            maxLength: 2,
            minLength: 2,
          },
          M: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12,
            maxLength: 2,
            minLength: 2,
          },
          Y: {
            mask: IMask.MaskedRange,
            from: 1900,
            to: 9999,
            minLength: 4,
          },
          h: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 23,
            minLength: 2,
          },
          m: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 59,
            minLength: 2,
          },
        },

        format,
        parse,
      };
    /**
     * * Маска года
     */
    case DatepickerTypeEnum.Year:
      return {
        mask: Date,
        pattern: "Y",
        eager: "append",
        autofix: "pad",
        lazy: true,
        overwrite: true,
        placeholderChar: " ",
        blocks: {
          Y: {
            mask: IMask.MaskedRange,
            from: 1900,
            to: 9999,
            minLength: 4,
          },
        },

        format,
        parse,
      };
    /**
     * * Маска месяца
     */
    case DatepickerTypeEnum.Month:
      return {
        mask: "M",
        lazy: true,

        blocks: {
          M: {
            mask: IMask.MaskedEnum,
            enum: locale.monthNames,
            matchValue: (estr: string, istr: string, matchFrom: number) =>
              IMask.MaskedEnum.DEFAULTS.matchValue(
                estr.toLowerCase(),
                istr.toLowerCase(),
                matchFrom
              ),
          },
        },
      };
    /**
     * * Маска недели
     */
    case DatepickerTypeEnum.Week:
      return {
        mask: "Неделя `0, `0000",
        eager: "append",
        autofix: "pad",
        lazy: true,
        overwrite: true,
        placeholderChar: " ",
        blocks: {
          "0": {
            mask: IMask.MaskedRange,
            from: 1,
            to: 53,
            maxLength: 2,
            minLength: 2,
          },
          "0000": {
            mask: IMask.MaskedRange,
            from: 1900,
            to: 9999,
            minLength: 4,
          },
        },
        format,
        parse,
      };
    /**
     * * Маска времени
     */
    case DatepickerTypeEnum.Time:
      return {
        mask: "h:`m",
        eager: "append",
        autofix: "pad",
        lazy: true,
        overwrite: true,
        placeholderChar: " ",
        blocks: {
          h: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 23,
            maxLength: 2,
            minLength: 2,
          },
          m: {
            mask: IMask.MaskedRange,
            from: 0,
            to: 59,
            maxLength: 2,
            minLength: 2,
          },
        },
        format,
        parse,
      };
  }
};
